import { __assign } from "tslib";
import moment from 'moment-timezone';
import { getMomentDate, getUtcOffset } from './date';
export var getDay = function (date, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        day: '2-digit',
    }, date, locale);
};
export var getWeekDay = function (date, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        weekday: 'short',
    }, date, locale);
};
export var getMonth = function (date, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        month: 'short',
    }, date, locale);
};
export var getFullDate = function (timestamp, timeZone, showYear, locale, showTimeZone) {
    if (showTimeZone === void 0) { showTimeZone = false; }
    return formatWithIntl({
        timeZone: timeZone,
        year: showYear ? 'numeric' : undefined,
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: showTimeZone ? 'short' : undefined,
    }, timestamp, locale);
};
export var getLongDate = function (timestamp, timeZone, showYear, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        month: 'short',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        year: showYear ? 'numeric' : undefined,
    }, timestamp, locale);
};
export var getShortDate = function (timestamp, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        weekday: 'short',
        month: 'short',
        day: '2-digit',
    }, timestamp, locale);
};
export var getYearMonthDay = function (timestamp, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        year: 'numeric',
        month: 'short',
        day: '2-digit',
    }, timestamp, locale);
};
export var getMonthDay = function (timestamp, timeZone, locale) {
    return formatWithIntl({
        timeZone: timeZone,
        month: 'long',
        day: 'numeric',
    }, timestamp, locale);
};
export var getTime = function (timestamp, timeZone, locale, showTimeZone) {
    if (showTimeZone === void 0) { showTimeZone = false; }
    return formatWithIntl({
        timeZone: timeZone,
        minute: '2-digit',
        hour: 'numeric',
        timeZoneName: showTimeZone ? 'short' : undefined,
    }, timestamp, locale);
};
export var getWeekday = function (timestamp, locale) {
    return formatWithIntl({
        weekday: 'long',
    }, timestamp, locale);
};
export var formatDates = function (startDate, endDate, timeZone, forceShowYear, locale, showTimeZone) {
    if (forceShowYear === void 0) { forceShowYear = false; }
    if (locale === void 0) { locale = 'en-US'; }
    if (showTimeZone === void 0) { showTimeZone = false; }
    var start = getMomentDate(startDate, timeZone);
    var end = endDate ? getMomentDate(endDate, timeZone) : null;
    var showYear = !isYearHidden(start, end) || forceShowYear;
    if (endDate) {
        var sameDay = start.isSame(end, 'day');
        var showStartDateTimeZone = showTimeZone && !sameDay;
        var formattedStart = getFullDate(startDate, timeZone, showYear, locale, showStartDateTimeZone);
        if (sameDay) {
            return formattedStart + " \u2013 " + getTime(endDate, timeZone, locale, showTimeZone);
        }
        else {
            return formattedStart + " \u2013 " + getFullDate(endDate, timeZone, showYear, locale, showTimeZone);
        }
    }
    return "" + getFullDate(startDate, timeZone, showYear, locale, showTimeZone);
};
export var isYearHidden = function (start, end) {
    var current = moment();
    return current.isSame(start, 'year') && current.isSame(end || moment(), 'year');
};
var formatWithIntl = function (options, timestamp, locale) {
    try {
        return new Intl.DateTimeFormat(locale, options).format(new Date(timestamp));
    }
    catch (_a) {
        try {
            var offset = getUtcOffset(timestamp, options.timeZone);
            var timeInTimeZone = getMomentDate(timestamp).add(offset, 'minutes').toISOString();
            return new Intl.DateTimeFormat(locale, __assign(__assign({}, options), { timeZone: 'UTC' })).format(new Date(timeInTimeZone));
        }
        catch (_b) {
            return moment(timestamp).tz(options.timeZone).format('LLL');
        }
    }
};
export var formatTimeZone = function (locale, timezone) {
    return new Intl.DateTimeFormat(locale, {
        timeZoneName: 'short',
        timeZone: timezone,
    })
        .formatToParts(new Date())
        .find(function (part) { return part.type === 'timeZoneName'; }).value;
};
export var formatDurationUnderHour = function (duration) { return moment.utc(duration).format('mm[:]ss'); };
//# sourceMappingURL=formatter.js.map